<template>
  <CFooter :fixed="false">
    <div>
      <a href="#" target="_blank">QUẢN LÝ TRUYỀN THANH CƠ SỞ</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} - {{new Date().getFullYear() + 1}}</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <!-- <a href="#" target="_blank">Team NEWTATCO</a> -->
      <a href="#" target="_blank">Team Vina DigiSign</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
